<template>
  <v-card>
    <v-layout>
      <v-card-title class="headline">
        <strong class="headline deep-purple--text">
          Revisão da previsão ({{dia_selecionado.type | forecastType}})
        </strong>
      </v-card-title>
    </v-layout>
    <v-divider class="deep-purple" />
    <v-layout v-if="!isTratamento" row wrap class="mx-4 mt-3">
      <v-flex xs12>
        <h4 class="deep-purple--text">CPP atual:</h4>
      </v-flex>
      <v-flex xs12 md2 class="mx-4">
        <v-sheet color="teal darken-4" height="60" elevation="3" dark>
          <blockquote class="blockquote">
            <h3 class="text-truncate">
              {{ cpp_estimado | numeral("$0,0.00") }}
            </h3>
          </blockquote>
        </v-sheet>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!isTratamento"
      row
      wrap
      justify-center
      align-baseline
      class="mx-3 mt-4"
      :persistent="true"
      style="gap: 1rem"
    >
      <v-flex xs12>
        <h4 class="deep-purple--text">Nova previsão:</h4>
      </v-flex>
      <v-flex xs12 sm12 md2>
        <v-text-field
          type="number"
          step="0.01"
          label="Orçamento"
          box
          v-model="revisao.budget"
        />
      </v-flex>
      <v-flex xs12 sm12 md1 style="justify-content: center; flex: 0">
        <v-icon>mdi-division</v-icon>
      </v-flex>
      <v-flex xs12 sm12 md2>
        <v-text-field
          type="number"
          step="1"
          label="Produção"
          box
          v-model="revisao.goal"
        />
      </v-flex>
      <v-flex xs12 sm12 md1 style="justify-content: center; flex: 0">
        <v-icon>mdi-equal</v-icon>
      </v-flex>
      <v-flex xs12 sm12 md2>
        <v-text-field
          type="text"
          label="CPP"
          outline
          :value="cpp_estimado"
          readonly
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
      align-baseline
      class="mx-3 mt-4"
      :persistent="true"
      style="gap: 1rem"
    >
      <v-flex xs12>
        <h4 class="deep-purple--text">Nova previsão:</h4>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-text-field
          type="number"
          step="0.01"
          label="Orçamento"
          box
          v-model="revisao.budget"
        />
      </v-flex>
    </v-layout>

    <v-divider class="deep-purple" />
    <v-card-actions class="py-2">
      <v-btn flat color="primary" @click="fechar_modal">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="deep-purple"
        dark
        @click="incluir_revisao"
        :disabled="esperar"
        >Salvar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["dia_selecionado", "esperar"],
  data() {
    return {
      revision_headers: [
        { text: "Orçamento", value: "budget" },
        { text: "Produção", value: "goal" },
        { text: "Revisão por", value: "created_by" },
        { text: "Data", value: "created_at" },
      ],
      revisao: {
        goal: 0,
        budget: 0,
      },
    };
  },
  mounted() {
    this.estado_inicial();
  },
  methods: {
    fechar_modal() {
      this.$emit("fechar");
      this.estado_inicial();
    },
    incluir_revisao() {
      this.$emit("incluir_revisao", this.revisao);
      this.estado_inicial();
    },
    estado_inicial() {
      if (this.dia_selecionado) {
        this.revisao = {
          goal: this.dia_selecionado.goal,
          budget: this.dia_selecionado.budget,
          type: this.dia_selecionado.type,
        };
      }
    },
  },
  computed: {
    cpp_estimado() {
      const cpp = parseFloat(this.revisao.budget) / parseInt(this.revisao.goal);
      if (isFinite(cpp)) {
        return cpp;
      } else {
        return 0;
      }
    },
    isTratamento() {
      return this.revisao.type === "LEMMIT_TREATMENT";
    },
  },
};
</script>
